import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'

type GroupDirection = 'row' | 'col'

export interface CheckboxGroupProps {
  direction?: GroupDirection
  error?: boolean
  helperText?: string
}

function Group({
  children,
  error = false,
  helperText = '',
  direction = 'col',
}: PropsWithChildren<CheckboxGroupProps>): JSX.Element {
  return (
    <div>
      <div
        className={clsx(
          `flex flex-${direction}`,
          direction === 'row' ? 'items-center' : '',
        )}
        role="group"
      >
        {children}
      </div>
      {helperText ? (
        <span
          aria-live={error ? 'assertive' : 'off'}
          className={clsx(
            'text-xs',
            error ? 'text-error-main' : 'text-black-60',
          )}
        >
          {helperText}
        </span>
      ) : null}
    </div>
  )
}

export default Group
